<template>
  <el-select
    size="mini"
    v-if="!disabled"
    :value="value"
    :clearable="clearable"
    @change="onChange"
    style="width: 100%"
    v-bind="$attrs"
    :validate-event="false"
  >
    <el-option
      v-for="item in items"
      :key="item.value"
      :disabled="dealDisabled(item.disabled)"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
  <span v-else>{{ text }}</span>
</template>
<script>
import EditMixin from "./edit-mixin";
export default {
  mixins: [EditMixin],
  props: {
    row: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, String, Boolean, Array],
      required: false,
    },
    options: {
      type: [Function, Array],
      required: true,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    text() {
      const item = this.items.find((item) => item.value === this.value);
      if (item) {
        return item.label;
      } else {
        return this.value;
      }
    },
  },
  created() {
    this.setOptions(this.options);
  },
  methods: {
    setOptions(options) {
      if (Object.prototype.toString.call(options) === "[object Function]") {
        const res = options(this.row);
        if (Object.prototype.toString.call(res) === "[object Promise]") {
          res.then((data) => {
            this.items = this.dealOptionItem(data);
          });
        } else {
          this.items = this.dealOptionItem(res);
        }
      } else {
        this.items = this.dealOptionItem(options);
      }
    },
    onChange(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
    dealDisabled(disabled) {
      if (typeof disabled === "function") {
        return disabled(this.row);
      } else {
        return disabled;
      }
    },
    dealOptionItem(options) {
      return options.map((item) => {
        if (typeof item === "object") {
          const { label, text, value, ...fields } = item;
          return {
            label: label === undefined ? text : label,
            value: value,
            ...fields,
          };
        } else {
          return {
            label: item,
            value: item,
          };
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
